import React from "react";

export default function Contact() {
  return (
    <div data-testid="contact-page" className="pt-28 pb-24 max-w-7xl mx-auto px-6 md:px-12">
      <p className="text-xs uppercase tracking-overline text-[#4A5D23] mb-4">Get in Touch</p>
      <h1 className="font-serif-display text-6xl md:text-8xl tracking-tighter leading-none">Say hello.</h1>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div className="border-t border-[#1A1A1A] pt-6">
          <p className="text-xs uppercase tracking-overline text-[#7A7A7A]">Export Sales</p>
          <p className="font-serif-display text-2xl mt-3">export@earthorg.in</p>
          <p className="text-sm text-[#4A4A4A] mt-1">+91 80 4900 0000</p>
        </div>
        <div className="border-t border-[#1A1A1A] pt-6">
          <p className="text-xs uppercase tracking-overline text-[#7A7A7A]">Press / Partnerships</p>
          <p className="font-serif-display text-2xl mt-3">hello@earthorg.in</p>
        </div>
        <div className="border-t border-[#1A1A1A] pt-6">
          <p className="text-xs uppercase tracking-overline text-[#7A7A7A]">Office</p>
          <p className="font-serif-display text-2xl mt-3 leading-tight">EarthOrg Ventures LLP<br/>Bengaluru, India · 560001</p>
        </div>
      </div>
    </div>
  );
}
